var PROJECT_PRIORITY_TYPE = {
    Focus: "Focus",
    Archive: "Archive"
};
var PROJECT_VIEW_TYPES = {
    timeline: "Timeline",
    list: "List"
};

var $ = null;
var Animation = class {};
var ASSETS = {
    Construct: function(jquery, animation) {
        $ = jquery;
        Animation = animation;
    },
    Timeline: {
        Get: async function(component, api, TimelineInstance, projectTypes, CONFIG) {
            const projectDateRange = await api.READ.ProjectDateRange(component, api.DataAPI);
            for (const projectType of projectTypes) {
                const { PriorityType, DateRange } = projectType;
                if (PriorityType === "Focus") {
                    DateRange.End = new Date().getFullYear();
                }
            }

            // Get timeline
            const startDate = new Date(projectDateRange.Start);
            const timeline = new TimelineInstance(
                startDate.getFullYear(),
                new Date().getFullYear(),
                CONFIG.timeline.order,
                projectTypes
            );
            component.timeline.years = timeline.data.years;
            component.timeline.totalYears = timeline.data.totalYears;

        },
        Navigation: {
            _component: null,
            Navigate: function(component, navigation) {
                const timeline = component.timeline;

                // Timeline width ("- 100" equates to overflow)
                const width = Number(navigation.width.replace("%", "")) - 100;

                const $timelineContent = $("#timeline #content");
                const { direction, hovering } = navigation.navigation;

                // Animate timeline, update navigation controls depending on timeline position
                if (direction === "Right") {
                    timeline.navigation.showLeftControl = true;
                } else {
                    timeline.navigation.showRightControl = true;
                }
                const duration = this.Duration($timelineContent, direction);
                const distance = direction === "Left" ? "0%" : `-${width}%`;
                const animation = new Animation(
                    $timelineContent,
                    "Left",
                    distance,
                    duration,
                    0,
                    function() {
                        timeline.navigation.showLeftControl = direction === "Right";
                        timeline.navigation.showRightControl = direction === "Left";
                    }
                );
                if (!hovering) {
                    animation.Stop();
                }

            },
            Duration: function($timelineContent, direction) {
                const left = Math.floor(Math.abs($timelineContent.offset().left));
                let duration = 0;
                if (direction === "Left" && left < $timelineContent.width() / 2) {
                    duration = 800;
                } else if (direction === "Right" && left > $timelineContent.width() / 2) {
                    duration = 800;
                } else {
                    duration = 3200;
                }
                return duration;
            },
            ToSelection: function(component, target) {
                component.previousX = target.clientX;
                component.Scrub(target);
            },
            Grab: function(component, target) {
                this._component = component;
                window.addEventListener("mousemove", component.Scrub);
                window.addEventListener("mouseup", this.Release);
                component.previousX = target.clientX;
            },
            Release: function() {
                window.removeEventListener("mousemove", ASSETS.Timeline.Navigation._component.Scrub);
                window.removeEventListener("mouseup", this.Release);
            }
        },

        // Prevent timeline from going out-of-bounds
        SetTimelineBounds: function(timeline, navigationWidth) {
            navigationWidth = navigationWidth - 100;
            const absoluteDistance = Number((Math.ceil(timeline.distance) + "").replace("-", ""));
            let showNavigationLeftControl, showNavigationRightControl;
            if (timeline.depth <= 0) {
                timeline.depth = 0;
                showNavigationLeftControl = false;
            } else {
                showNavigationLeftControl = true;
            }
            if (absoluteDistance >= navigationWidth) {
                showNavigationRightControl = false;
            } else {
                showNavigationRightControl = true;
            }
            timeline.navigation.showLeftControl = showNavigationLeftControl;
            timeline.navigation.showRightControl = showNavigationRightControl;
        },

        Configure: function(component, configurations) {
            component.timeline.configurations.attached = configurations.attached;
            component.$emit("timeline-configurations", component.timeline.configurations);
        },
        Show: function(component, attached) {
            return component.timeline.years && component.welcomeComplete && attached;
        },
        SetConfigurations: function(component) {
            component.timeline.configurations = component.timelineConfigurations;
        },
        MonthHeight: function(CONFIG) {
            const { dayHeight, daysPerMonth } = CONFIG.timeline;
            return `${dayHeight * daysPerMonth}px`;
        },
        Height: function(CONFIG) {
            return Number(this.MonthHeight(CONFIG).replace("px", "")) * 12;
        },

        // Get project timeline data (if loaded, pull from cache)
        Load: async function(component, useLoader, api, store, projectID, timelineProjectMapID) {
            if (!projectID) {
                projectID = -1;
            }
            if (!timelineProjectMapID) {
                timelineProjectMapID = -1;
            }
            if (useLoader) {
                component.$emit("start-loader", "#app");
            }

            // Get timeline data
            let loaded = false;
            const timelineData = await api.READ.TimelineData(component, api.DataAPI);
            if (timelineData) {
                loaded = true;
            }
            component.timeline.data = timelineData;
            store.state.projectID = projectID;
            store.state.timelineProjectMapID = timelineProjectMapID;
            store.state.loaded = loaded;
            ASSETS.SetStorage("Portfolio", store.state);

            if (useLoader) {
                component.$emit("stop-loader");
            }
        }

    },
    GetStorage: function(item) {
        return JSON.parse(localStorage.getItem(item));
    },
    SetStorage: function(item, data) {
        localStorage.setItem(item, JSON.stringify(data));
    },
    Mobile: {
        _mobile: false,
        LoadProjects: async function(component, api, store, projectID, timelineProjectMapID) {
            const projects = await api.READ.ProjectListByCategory(component, api.DataAPI);
            let loaded = false;
            if (projects && !projects.length) {
                loaded = false;
            } else {
                loaded = true;
                SEARCH.ResetCategoryFilterCount(projects);
            }
            store.state.loaded = loaded;
            if (projectID) {
                store.state.projectID = projectID;
            }
            if (timelineProjectMapID) {
                store.state.timelineProjectMapID = timelineProjectMapID;
            }
            ASSETS.SetStorage("Portfolio", store.state);
            component.projectList = projects;
        }
    },
    CleanURL: function(project) {
        return project
            .replace(/\s+/g, "-").toLowerCase()
            .replace(/&/g, "and")
            .replace(/'/g, "")
            .replace(/\(|\)/g, "")
            .replace(/---/g, "-");
    },
    PriorityType: {
        Focused: function(component) {
            return component.priority.PriorityType === PROJECT_PRIORITY_TYPE.Focus;
        },
        DateRange: function(component, dates) {
            if (this.Focused(component)) {
                return dates.Start;
            }
            return `${dates.Start} &mdash; ${dates.End}`;
        }
    },
    Projects: {
        View: function(component, store, project, formattedProject, projectName, route) {
            const { ProjectID, TimelineProjectMapID } = project;
            store.state.projectID = ProjectID;
            store.state.timelineProjectMapID = TimelineProjectMapID;
            ASSETS.SetStorage("Portfolio", store.state);
            component.$router.push({
                name: route.name,
                params: { name: formattedProject },
                meta: { id: ProjectID }
            });
            component.$emit("project", {
                projectID: ProjectID,
                name: projectName,
                timelineProjectMapID: TimelineProjectMapID
            });
        },
        ViewType: function(settings) {
            let projectViewType = {};
            if (settings) {
                projectViewType = settings.projectViewType
            } else {
                projectViewType = {
                    view: "Timeline",
                    show: false
                };
            }
            return projectViewType;
        },
        SetTypes: function(component, projectTypes) {
            if (projectTypes) {
                const totalProjectTypes = projectTypes.length;
                for (let t = 0; t < totalProjectTypes; t++) {
                    const type = component.search.types[t];
                    component.search.types[t] = {
                        selected: type ? type.selected : false,
                        value: projectTypes[t].Name
                    };
                }
            }
        }
    },
    CustomAccoladeName: function(category) {
        let name = "";
        if (category === "Awards") {
            name = "Awards & Honors";
        } else {
            name = category;
        }
        return name;
    }
};

var SEARCH = {

    // Reset category filter count
    ResetCategoryFilterCount: function(projects) {
        for (const project of projects) {
            for (const type of project.Types) {
                type.CategoryFilteredTotal = 0;
            }
        }
    },

    Set: function(component, search) {
        const { index, selected, value } = search;
        component.search.types[index].selected = selected;
        component.search.types[index].value = value;
        component.search.changeMade = true;
    },
    DeselectAllSearchTypes: function(component) {
        for (const type of component.search.types) {
            type.selected = false;
        }
    }
};

var TIMELINE_CONFIGURATIONS = {
    configurations: {
        name: "Configurations",
        main: true,
        icons: {
            active: "IconConfigurationsActive.png",
            inactive: "IconConfigurationsInactive.png"
        },
        show: true
    },
    yBarExpanded: {
        name: "Expand",
        icons: {
            active: "IconYBarExpandedActive.png",
            inactive: "IconYBarExpandedInactive.png"
        },
        show: true
    },
    yBarCollapsed: {
        name: "Collapse",
        icons: {
            active: "IconYBarCollapsedActive.png",
            inactive: "IconYBarCollapsedInactive.png"
        },
        show: false
    },
    attach: {
        name: "Attach",
        icons: {
            active: "IconAttachActive.png",
            inactive: "IconAttachInactive.png"
        },
        show: true
    },
    detach: {
        name: "Detach",
        icons: {
            active: "IconDetachActive.png",
            inactive: "IconDetachInactive.png"
        },
        show: false
    },
    zoom: {
        name: "Zoom",
        icons: {
            active: "IconZoomActive.png",
            inactive: "IconZoomInactive.png"
        },
        show: true
    }
};

class ItemReveal {
    items = [];
    initialCount = 0;
    revealAmount = 0;
    constructor(items, initialCount, revealAmount) {
        this.items = items;
        this.initialCount = initialCount;
        this.revealAmount = revealAmount;
    };
    Remaining = function() {
        const remaining = this.items.length - this.revealAmount;
        if (remaining > 0) {
            return remaining;
        }
    };
    AdditionalItems = function() { return this.Remaining() > 0; };
    Reveal = function(revealAmount) {
        this.revealAmount += revealAmount;
        if (this.Remaining() < this.initialCount) {
            this.initialCount = this.Remaining();
        }
    };
};

var SETTINGS = {
    Select: function(component, setting) { component.projectViewType = setting.selected; },
    Set: function(component) {
        const portfolio = ASSETS.GetStorage("Portfolio");
        component.projectViewType = portfolio
            ? portfolio.settings.projectViewType
            : "";
    }
};

var BUTTON_TYPES = {
    prominent: "Prominent",
    off: "Off"
};

var PROFILES = {
    main: "Main",
    paletteSummary: "Palette Summary"
};

var ACCESSIBILITY = {

    // Accessibility - Timeline keyboard navigation
    TimelineNavigation: function(id, Action) {
        window.addEventListener("keydown", function(e) {
            const contentFocused = $(`#${id}`).is(":focus");
            if ([
                "Space",
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(e.code) > -1 && contentFocused) {
                e.preventDefault();
                Action(e.code);
            }
        });
    }

};

module.exports = {
    ASSETS,
    TIMELINE_CONFIGURATIONS,
    PROJECT_PRIORITY_TYPE,
    PROJECT_VIEW_TYPES,
    ItemReveal,
    SETTINGS,
    BUTTON_TYPES,
    SEARCH,
    PROFILES,
    ACCESSIBILITY
};